import type { AuthError, Session, User } from "@supabase/supabase-js";
import { createContext } from "react";

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  signIn: (email: string, password: string, captchaToken?: string | null) => Promise<{ error: AuthError | null }>;
  signUp: (params: {
    email: string;
    password: string;
    full_name: string;
    options?: { captchaToken?: string | null };
  }) => Promise<{ error: AuthError | null }>;
  signOut: () => Promise<void>;
  resetPassword: (email: string, captchaToken?: string | null) => Promise<{ error: AuthError | null }>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);